import React, { useEffect } from 'react';

import LuxuryHomesFeaturedDestinations from './featured-destinations';
import LuxuryHomesFeaturedProperties from './featured-properties';
import LuxuryHomesOurLocations from './our-locations';
import { LuxuryHomesHero } from './hero';

import { LuxuryHomesMain } from '../commons/main/component';

import { Routes } from '@share/constants';

import './style.scss';

export const LuxuryHomesHome: React.FC = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <LuxuryHomesMain route={Routes.LuxuryHomes} childrenHero={<LuxuryHomesHero />} hideBackButton>
      <LuxuryHomesFeaturedDestinations />
      <LuxuryHomesFeaturedProperties />
      <LuxuryHomesOurLocations />
    </LuxuryHomesMain>
  );
};
